import { Stack,TooltipHost } from "@fluentui/react";
import React, { useContext, useEffect } from "react";
import RowBadge from "./Badge/RowBadge";
import ChatIcon from "../../../components/SVGComponents/ChatIcon";
import studylistContext from "../../../context/studylist/StudylistContext";
import { CUSTOM_STYLES, HIDE_ALERT_RAISE, REINFERECE_ALLOWED_MODALITY, REPORTDONESTATUS, REPORT_DONE_STATUS, SHOW_RETURNED_ROLES, TAB_NAME, USERTYPES, modalityRowBadgeColor, widthOfColumns } from "../../../constants/Constants";
import userContext from "../../../context/users/UserContext";
import { ClosePaneIcon } from "@fluentui/react-icons-mdl2";
import InfoIcon from "../../../components/SVGComponents/InfoIcon";
import ErrorIcon from "../../../components/SVGComponents/ErrorIcon";
import { t } from "i18next";
import CustomToolTipHost from "../../../components/CustomToolTipHost/CustomToolTipHost";
import { capitalizeFullName } from "../helpers/helpingFunctions";
import themeContext from "../../../context/theme/ThemeContext";
import { toolTipStyles } from "../../StudyViewer/styles/styles";
const studyDetailsContainer = {
  display: "flex",
  flex: "1",
  position: "relative",
  cursor: "pointer", 
};

const patientAgeChatContainer = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginTop: "5px"
};
const patientAgeContainer = {
  display: "flex",
  flex: "0.5",
  paddingRight:"25px",
  cursor: 'text'
};


const PatientDetails = (props) => {
  const {
    returnedReasonCount,
    setShowCommunicationModal,
    showReturnedStudyReasonModal,
    setShowReturnedStudyReasonModal,
    rowSelectedArray,
    trackOfVisisted, setTrackOfVisited,
    filterInputValues,
    isTypistWorkflowEnabled
  } = useContext(studylistContext);

  const {roles,userId,username, name} = useContext(userContext);
  const { themeName, getThemeColor } = useContext(themeContext);

  let isBvpPlatform = (process.env.REACT_APP_BVP_PLATFORM == "true" || process.env.REACT_APP_BVP_PLATFORM == true) ? true : false;

  const extractCorrectAge = (str) => {
    if (str[str.length - 1] == "Y" && str[0] == "0") {
      return str.substring(1, str.length - 1);
    }
    return str;
  };

  const getReturnedStudyCount = (study_id) => {
    let count = 0;
    if (returnedReasonCount.length > 0) {
      count = returnedReasonCount.filter((ele, index) => {
        return ele.studyId == study_id;
      })[0]?.noOfReasons;
    }
    return count > 0 ? count : null;
  };



  const badgeStyle = {
    marginLeft: "2px",
    backgroundColor: "#BBDEFF",
    height: "18px",
    fontSize: "10px",
    color: "#0035BE",
    display: "flex",
    alignItems: "center",
    width: "fit-content",
    fontFamily: "Open Sans",
    fontWeight: "700",
    padding: "0px 5px",
    borderRadius: "10px",
    lineHeight: "16px",
    gap: "10px",
  };


  const getTrackedOfVisited = (study) => {
    return trackOfVisisted.includes(study.id);
  }

  const checkIfCannotDelete = (study) => {
    if((study.assignmentList[0].clientId == 0 && (study.reportDoneStatus > 0 || study.assignmentList[0].providerId != null)) &&
    study.assignmentList[0].firmName != 'firsthospital'
    ){
      return true;
    }else if(((study.assignmentList[0].clientId == 0 || (study?.studyFromMinimalFirm && study?.sourceFirmId == study.assignmentList[0].clientId)) && study.reportDoneStatus == 0 && study.assignmentList[0].providerId == null)
    ||  study.assignmentList[0].firmName == 'firsthospital'
    ){
      return false;
    }else{
      return true;
    }
  }

  const checkIfCannotDeleteImages = (study) => {
    // console.log(study);
    if((study.assignmentList[0].clientId == 0 && (study.reportDoneStatus > 0 || study.assignmentList[0].providerId != null)) &&
    study.assignmentList[0].firmName != 'firsthospital'
    ){
     
        return false;
    }else if(((study.assignmentList[0].clientId == 0 || (study?.studyFromMinimalFirm && study?.sourceFirmId == study.assignmentList[0].clientId)) && study.reportDoneStatus == 0 && study.assignmentList[0].providerId == null)
    ||  study.assignmentList[0].firmName == 'firsthospital'
    ){
      if(study.clientBillingStudy && study.noOfImages > 0)
        return true;
      else
        return false;
    }else{
        return false;
    }
  }

  const checkIfCannotReinference = (study) => {
    if((REINFERECE_ALLOWED_MODALITY.includes(study.modality.name) && study.triageXRAYStudies && study.reportDoneStatus != 2) && !study.genkiStudy){
      return true;
    }else{
      return false;
    }
  }

  const getAccessionNumber = ()=>{
    return filterInputValues?.showAccessionNumber ? ' | ' +props.data.row.original.accessionNumber: '';
  }

  const customPatientColumnTooltip = {
    root: "study-list-patientDetails-name study-list-min-width",
  }

  const customPatientIdTooltip = {
    root: "study-list-patientDetails-id-txt"
  }
  const customOrderIdTooltip={
    root:process.env.REACT_APP_VDC_PLATFORM == "true" ?"":"study-list-patientDetails-id-txt"
  }

  const checkForAnyTopTagExist = () => {
    if((props.data.row.original.edited &&
      props.data.row.original.reportDoneStatus <= 2)
      || ((props.data.row.original.visited != null && props.data.row.original.visited != undefined &&
        props.data.row.original.visited) || getTrackedOfVisited(props.data.row.original))
      ||
      (props.data.row.original.assignmentList[0].reportDoneStatus ===
        REPORT_DONE_STATUS.REPORTED && props.data.row.original.raiseAlertAttention && props.data.row.original.raiseAlert != "")
      ||
      props.data.row.original.assignmentList[0]?.priority == true
      ||
      (roles.length > 0 && SHOW_RETURNED_ROLES.includes(roles[0]) && getReturnedStudyCount(props.data.row.original.id) != null)
      ){
        return true;
      }
      return false;
  }

  const mainStackStyles = {
    justifyContent: "center",
    marginTop: checkForAnyTopTagExist()? CUSTOM_STYLES.STUDYLIST_TD_TOP_MARGIN : CUSTOM_STYLES.STUDYLIST_TD_TOP_MARGIN,
    paddingLeft: props.data.row.depth === 0 ? "unset" : "20px"
  };

  const checkAndGetAccessCode = ()=>{
    if(  props.data.row.original.assignmentList[0]?.studyAccessCode == null || props.data.row.original.assignmentList[0]?.studyAccessCode === undefined  ){
      
      return false;
    }else{
      if(props.data.row.original.assignmentList[0]?.providerId==  "R" + userId && props.data.row.original.reportDoneStatus  < 2 ) 
        return true;
      else{
        return false;
      }
    }
  }
  const priorMismatchToolTip={
    calloutProps: {
      styles: {
        beak: { background: getThemeColor("tooltip") },
        beakCurtain: { background: getThemeColor("tooltip") },
        calloutMain: { background:getThemeColor("tooltip"), height:"75px",width:"160px"},
        borderRadius: "5px",
        boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
      },
    },
  }

  const checkAndGetAssignedTypist = ()=>{
    if(  props.data.row.original.typistId == null || props.data.row.original.typistId === 0  ){
      
      return false;
    }else{
      if(props.data.row.original.typistId === userId) 
        return true;
      else{
        return false;
      }
    }
  }


  return (
    <>
      <Stack style={{ ...mainStackStyles }} data-tut={`tour-patient-details`}>

        <div style={studyDetailsContainer}>
        <CustomToolTipHost  styles={{ height: "24px",display: "flex",alignItems: "center"}} toolTipProps={priorMismatchToolTip} content={t("study-list.messages.prior-mismatch")}>{props.data.row.original.priorMismatch  && <ErrorIcon></ErrorIcon>}</CustomToolTipHost>
        {props.data.row.original.priorMismatch && <div style={{width:'5px'}}></div>}
        <CustomToolTipHost styles={customPatientColumnTooltip} content={`${t("patient.name")}: ${capitalizeFullName(props.data.row.original.patientName)}`} id={"tooltip_"}>
              {capitalizeFullName(props.data.row.original.patientName)}
          </CustomToolTipHost>
          </div>
            <span className="study-list-patientDetails-id">
              {process.env.REACT_APP_VDC_PLATFORM == "true" && props.data.row.depth === 0 && 
              <div style={{display:"flex", flexDirection:"column"}}>
                <TooltipHost styles={customOrderIdTooltip} content={`Order Id : ${props.data.row.original.orderId}`} id={"tooltip_"}>O:{`${props.data.row.original.orderId}`}</TooltipHost>
                <TooltipHost styles={customOrderIdTooltip} content={`Accession Number : ${props.data.row.original.accessionNumber}`} id={"tooltip_"}>A:{`${props.data.row.original.accessionNumber}`}</TooltipHost>
                <TooltipHost styles={customOrderIdTooltip} content={`Patient Id : ${props.data.row.original.patientId}`} id={"tooltip_"}>P:{`${props.data.row.original.patientId}`}</TooltipHost>
              </div>}
              {process.env.REACT_APP_VDC_PLATFORM == "false" && props.data.row.depth === 0 && 
              <div style={{display:"flex", flexDirection:"column"}}>
                <TooltipHost styles={customPatientIdTooltip} content={`Patient Id : ${props.data.row.original.patientId}`} id={"tooltip_"}>P:{`${props.data.row.original.patientId}`}</TooltipHost>
                <TooltipHost styles={customPatientIdTooltip} content={`Accession Number : ${props.data.row.original.accessionNumber}`} id={"tooltip_"}>A:{`${props.data.row.original.accessionNumber}`}</TooltipHost>
              </div>
                // <CustomToolTipHost styles={customPatientIdTooltip} content={`${t("error-study-list.id").toUpperCase()} : ${props.data.row.original.patientId} ${getAccessionNumber()}`} id={"tooltip_"}>
                // {`${props.data.row.original.patientId}`}{" "} {getAccessionNumber()}
                // </CustomToolTipHost>
              }
            </span>
            {/* <RowBadge name={props.data.row.original.modality.name} colorObj={modalityRowBadgeColor(props.data.row.original.modality.name)} /> */}
            <span className="study-list-top-badge-container">

            {props.data.row.depth == 0 && rowSelectedArray.includes(props.data.row.index) ? checkIfCannotDelete(props.data.row.original) ? (
                  <CustomToolTipHost content={t("study-list.messages.cannot-batch-delete")} id={"tooltip_"}>
                  <span
                    className="study-list-top-badge-item"
                    style={{ color: "white", background: " red",alignItems:'center' ,whiteSpace:'nowrap' }}
                  >
                   {/* <InfoIcon />&nbsp;  */}
                   {t("study-list.actions.delete-study")}
                  </span></CustomToolTipHost>
                ):
                <CustomToolTipHost content={t("study-list.messages.added-batch-delete")} id={"tooltip_"}>
                  <span
                    className="study-list-top-badge-item"
                    style={{ color: "white", background: " green",alignItems:'center',whiteSpace:'nowrap' }}
                  >
                   {/* <InfoIcon />&nbsp;  */}
                   {t("study-list.actions.delete-study")}
                  </span></CustomToolTipHost>
                :<></>}

            {props.data.row.depth == 0 && rowSelectedArray.includes(props.data.row.index) && checkIfCannotDeleteImages(props.data.row.original) && (
                  <CustomToolTipHost content={t("study-list.messages.added-batch-delete-image")} id={"tooltip_"}>
                  <span
                    className="study-list-top-badge-item"
                    style={{ color: "white", background: " green",alignItems:'center',whiteSpace:'nowrap'  }}
                  >
                   {/* <InfoIcon />&nbsp;  */}
                   {t("study-list.actions.delete-image")}
                  </span></CustomToolTipHost>
                )}

            {props.data.row.depth == 0 && rowSelectedArray.includes(props.data.row.index) ? !checkIfCannotReinference(props.data.row.original) ? (
                  <CustomToolTipHost content={t("study-list.messages.cannot-batch-reinference")} id={"tooltip_"}>
                  <span
                    className="study-list-top-badge-item"
                    style={{ color: "white", background: " red",alignItems:'center',whiteSpace:'nowrap' }}
                  >
                   {/* <InfoIcon />&nbsp;  */}
                   {t("study-list.actions.reinference")}
                  </span></CustomToolTipHost>
                ):
                <CustomToolTipHost content={t("study-list.messages.added-batch-reinference")} id={"tooltip_"}>
                <span
                  className="study-list-top-badge-item"
                  style={{ color: "white", background: " green",alignItems:'center',whiteSpace:'nowrap'  }}
                >
                 {/* <InfoIcon />&nbsp;  */}
                 {t("study-list.actions.reinference")}
                </span></CustomToolTipHost>
              :<></>}

              {(isBvpPlatform && props.data.row.original.reviewPending && props.data.row.original.reportDoneStatus == 1) && (
                  <span
                    className="study-list-top-badge-item"
                    style={{ color: "#312404", background: "#f5942d" }}
                  >
                    {t("study-list.badges.review-pending").toUpperCase()}
                  </span>
                )}
              {(props.data.row.original.edited &&
                props.data.row.original.reportDoneStatus <= 2) && (
                  <span
                    className="study-list-top-badge-item"
                    style={{ color: "#312404", background: " #f5bd2d" }}
                  >
                    {t("study-list.badges.edited").toUpperCase()}
                  </span>
                )}
                {((props.data.row.original.visited != null && props.data.row.original.visited != undefined &&
                props.data.row.original.visited) || getTrackedOfVisited(props.data.row.original)) && (
                  <span
                    className="study-list-top-badge-item"
                    style={{ color: "#312404", background: "rgb(223 173 173)" }}
                  >
                    {t("study-list.badges.visited").toUpperCase()}
                  </span>
                )}
                {
                props.data.row.original.assignmentList[0]?.priority == true && (
                  <span
                    className="study-list-top-badge-item"
                    style={{ color: "#312404", background: "#4df53d" }}
                  >
                    {t("study-list.badges.new").toUpperCase()}
                  </span>
                )}
                {(props.data.row.original.storageType === 2 || props.data.row.original.storageType === 3) && (
                  <CustomToolTipHost content={props.data.row.original.storageType === 2 ? "ARCHIVED" : "AVAILABLE: " + props.data.row.original.daysLeftForExpiry + " Days Left"} id={"tooltip_"}>
                  <span
                    className="study-list-top-badge-item"
                    style={{  whiteSpace:"nowrap", color: "#312404", background: props.data.row.original.storageType === 2 ? "#c1c1c1" : "rgb(51 222 247)", }}
                  >
                    {props.data.row.original.storageType === 2 ? "ARCHIVED" : "AVAILABLE: " + props.data.row.original.daysLeftForExpiry + "D"}
                  </span> </CustomToolTipHost>
                )}
              {roles.length > 0 && SHOW_RETURNED_ROLES.includes(roles[0]) && getReturnedStudyCount(props.data.row.original.id) != null && (
                <span
                  onClick={() => {
                    setShowReturnedStudyReasonModal({
                      studyId: props.data.row.original.id,
                      show: true,
                    });
                  }}
                  className="study-list-top-badge-item"
                  style={{ color: "rgb(3 52 98)", background: "#59ADFA",whiteSpace:"nowrap" }}
                >{`${t("study-list.badges.returned").toUpperCase()} ${getReturnedStudyCount(
                  props.data.row.original.id
                )}`}</span>
              )}

              {/*Study access code*/}
              {roles.length > 0 && roles[0].includes(USERTYPES.RADIOLOGIST) && (isTypistWorkflowEnabled==1) && checkAndGetAccessCode()  && (
                <span
                  
                  className="study-list-top-badge-item"
                  style={{ color: themeName === "light"?"white":"rgb(3 52 98)", background: "grey" , whiteSpace:"nowrap", fontFamily:"Consolas", fontSize:"11px"}}
                >{`${t("study-list.badges.access-code").toUpperCase()} ${
                  props.data.row.original.assignmentList[0]?.studyAccessCode
                }`}</span>
              )}

              {/*Study assigned to typist*/}
              {roles.length > 0 && roles[0].includes(USERTYPES.TYPIST) && checkAndGetAssignedTypist()  && (
                <span
                  
                  className="study-list-top-badge-item"
                  style={{ color: themeName === "light"?"white":"rgb(3 52 98)", background: "grey" , whiteSpace:"nowrap"}}
                >{` ${
                  name
                }`}</span>
              )}


              {(roles.length > 0 && !HIDE_ALERT_RAISE.includes(roles[0]) && (props.data.row.original.assignmentList[0].reportDoneStatus ===
            REPORT_DONE_STATUS.REPORTED || props.data.row.original.assignmentList[0].reportDoneStatus === REPORT_DONE_STATUS.SAVED) && props.data.row.original.raiseAlertAttention && props.data.row.original.raiseAlert != "" && !(props.data.row.original.peerReviewAssignment?.reviewerId == userId && (props.tabId == TAB_NAME.REVIEWASSIGNED || props.tabId == TAB_NAME.REVIEWCOMPLETE))) &&
                  <div style={{ display: "flex" }}>
                    <CustomToolTipHost
                      //styles={customToolTipRaiseAlertStyles}
                      content={`${t("study-list.badges.raise-alert")}: `+props.data.row.original.raiseAlert}
                      id={"tooltip_"}
                    >
                      <span
                        className="study-list-top-badge-item"
                        style={{ color: "rgb(55 38 6)", background: "rgb(245 173 41 / 69%)",whiteSpace:'nowrap'  }}
                      >
                        {t("study-list.badges.raise-alert").toUpperCase()}
                      </span>
                    </CustomToolTipHost>
                  </div>}
            </span>
          
        <div style={patientAgeChatContainer}>
          <div style={patientAgeContainer}>
          <CustomToolTipHost
                      //styles={customToolTipRaiseAlertStyles}
                      content={`Gender: ${props.data.row.original.patientSex} & Age: ${props.data.row.original.patientAge == 0
                        ? props.data.row.original.patientAge.substring(1)
                        : extractCorrectAge(props.data.row.original.patientAge)}`}
                      id={"tooltip_"}
                    >
            <span className="study-list-patient-age">
              {props.data.row.original.patientSex}
            </span>
            <span className="study-list-patient-age-separator" style={{ marginLeft: "4px", marginRight: "4px" }}>|</span>
            <span className="study-list-patient-age">
              {props.data.row.original.patientAge == 0
                ? props.data.row.original.patientAge.substring(1)
                : extractCorrectAge(props.data.row.original.patientAge)}
            </span>
            </CustomToolTipHost>
          </div>
        </div>
      </Stack>
    </>
  );
};

export default PatientDetails;


